@if (isBogEnabled) {
    <div class="bog-block" [ngClass]="{ 'bog-bg': bogLabelStyle, 'bog-bg-settled': isSettled === true }" data-crlat="bogIcon">
        <svg class="bog-icon" height="8px" width="12px"><use [attr.xlink:href]="!isFromMyBets ? '#bog-text' : '#bog-text-black'"></use></svg>
        @if (!isFromMyBets) {
            <span class="bog-label" [i18n]="'app.bogLabel'"></span>
        }
    </div>
}
